export enum TellentDevFlag {
  OneBilling = 'one_billing_released',
  UnifiedGroups = 'unified_groups',
  UnifiedDepartments = 'unified_departments',
  AppShell = 'app_shell',
  IntelligenceSettings = 'intelligence_settings',
  OneSettings = 'one_settings',
  OneDomain = 'one_domain',
  OneDomainSettings = 'one_domain_settings',
  UsersWithoutEmails = 'users_without_emails',
  SharedAnalyticsEndpoints = 'shared_analytics_endpoints',
  IntercomUsersGuidBased = 'intercom_users_guid_based',
}

export type TellentDevFlagsMap = Record<TellentDevFlag, boolean>;

export type DevFlagsFetchResponse = {
  data: TellentDevFlag[];
};
